import React from "react";
import { useNavigate } from "react-router-dom";
import { SeoHead } from "../../components/SeoHead";
import { ARTICLES } from "../../../content/blog/registry";
import "./BlogIndexPage.css";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

// Примерное время чтения по длине описания (заглушка — реальное считается в MarkdownPage)
const READ_TIME: Record<string, number> = {
  "skolko-stoit-reklama-u-blogera-instagram": 5,
  "reklama-v-instagram-zakon-2026": 7,
  "kak-kupit-reklamu-u-blogera-instagram": 8,
  "mediakitblokera-chto-eto-i-kak-sdelat": 5,
  "kak-proverit-blogera-na-nakrutku-instagram": 6,
  "kak-monetizirovat-instagram-2026": 7,
};

export const BlogIndexPage: React.FC = () => {
  const navigate = useNavigate();
  const sorted = [...ARTICLES].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
  const [featured, ...rest] = sorted;

  return (
    <>
      <SeoHead
        title="Блог о рекламе у блогеров и Instagram-маркетинге"
        description="Статьи для рекламодателей и блогеров: цены на рекламу, проверка накрутки, медиакит, маркировка и монетизация Instagram."
        canonical="/blog"
        type="website"
      />

      <div className="blog-index">
        {/* Hero */}
        <div className="blog-hero">
          <div className="blog-hero__inner">
            <p className="blog-eyebrow">Блог</p>
            <h1 className="blog-hero__title">
              Реклама у блогеров<br />и Instagram-маркетинг
            </h1>
            <p className="blog-hero__lead">
              Практические руководства для рекламодателей и блогеров
            </p>
          </div>
        </div>

        <div className="blog-body">
          {/* Featured */}
          {featured && (
            <article
              className="blog-featured"
              onClick={() => navigate(`/blog/${featured.slug}`)}
              role="link"
              tabIndex={0}
              onKeyDown={e => e.key === "Enter" && navigate(`/blog/${featured.slug}`)}
            >
              <div className="blog-featured__meta">
                <span className="blog-tag">Новое</span>
                <span className="blog-date">{formatDate(featured.publishedAt)}</span>
                {READ_TIME[featured.slug] && (
                  <span className="blog-read-time">{READ_TIME[featured.slug]} мин</span>
                )}
              </div>
              <h2 className="blog-featured__title">{featured.title}</h2>
              <p className="blog-featured__desc">{featured.description}</p>
              <span className="blog-featured__link">Читать статью →</span>
            </article>
          )}

          {/* Grid */}
          {rest.length > 0 && (
            <div className="blog-grid">
              {rest.map(article => (
                <article
                  key={article.slug}
                  className="blog-card"
                  onClick={() => navigate(`/blog/${article.slug}`)}
                  role="link"
                  tabIndex={0}
                  onKeyDown={e => e.key === "Enter" && navigate(`/blog/${article.slug}`)}
                >
                  <div className="blog-card__meta">
                    <span className="blog-date">{formatDate(article.publishedAt)}</span>
                    {READ_TIME[article.slug] && (
                      <span className="blog-read-time">{READ_TIME[article.slug]} мин</span>
                    )}
                  </div>
                  <h3 className="blog-card__title">{article.title}</h3>
                  <p className="blog-card__desc">{article.description}</p>
                  <span className="blog-card__link">Читать →</span>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
